export default __webpack_public_path__ + "static/media/ttb.43c25804.svg";